module.exports = __webpack_public_path__ + "img/logo.3fc4c68d.svg";